import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from '../../../styles/constants';

export const useStyles = makeStyles(theme => ({
	list: {
		border: `1px solid ${COLORS.BORDER}`,
		'& .MuiButtonBase-root': {
			color: '#212529',
			fontSize: 16,
			'&:hover': {
				backgroundColor: 'transparent',
				color: '#2A78B8'
			}
		},
		'& .MuiLink-root': {
			textDecoration: 'none'
		}
	},
	button: {
		height: '21px',
		color: '#212529',
		fontWeight: '700',
		textTransform: 'none',
		padding: 0,
		bottom: 10,
		'&:hover': {
			backgroundColor: 'transparent'
		},
		'&:focus': {
			outline: '2px solid black'
		}
	},
	popper: {
		zIndex: 1
	}
}));
